module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "chapter-number-only",
    attrs: {
      "id": "_idParaDest-2",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("CHAPTER ONE")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Miss?” The voice rode the wavering lamplight so softly through the crack in the door that Lola Wicks sank back toward sleep, soothed by the customary noises in the next room. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The endless gurgle of tea into cracked cups. Breathy fricatives of Pashto. The metallic ratchet of magazines locking into place in preparation for the coming day. Lola slid lower in her sleeping bag, inhaling the pleasurable scent of woodsmoke and dung that signaled her most recent foray from Kabul into the highlands, entire centuries falling away the farther she traveled from the city, the only signs of modernity in these mountain villages the terrible weapons hoisted by cloaked men in sandals. The conflict was close here, not like Kabul, where men postured around conference tables with the occasional anonymous grenade tossed through a window to keep things interesting. In the highlands, combatants knew one another’s names. It had taken her months to gain the trust of this particular faction, whose stated purpose was to drive the Americans from Afghanistan’s borders even more decisively than they’d dealt with the Russians two decades earlier. Despite the risks of leaving Kabul’s questionable safety, any return to the outlying regions always felt like a sort of homecoming to Lola, a welcome respite from filing her stories in the crowded villa whose outlandish expense she shared with a shifting, quarreling cast of other foreign correspondents. Distractions and obligations peeled away as she traveled, until she arrived at a destination where filing the story and staying alive remained the only two things that mattered. Lola pulled the bag tighter around her head. It was mid-June but nights still snapped with cold in these lower reaches of the Hindu Kush.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Miss.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The door opened wider. Her fixer again, his voice insistent. Lola sat up and reached for her headscarf, the only article of clothing she discarded at night, even keeping her boots on, the laces merely loosened. “"), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Ho,")]), _vm._v("” she murmured. Yes.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“A call, miss.” He scooted her beeping satellite phone, freed from its generator recharge, across the dirt floor. It came to a stop against the edge of a rug whose rich dyes and labyrinthine swirls mocked the spartan surroundings. Lola cursed quietly, in English. Not even the most publicity-hungry warlord would call her at this hour. It had to be an editor. She flipped open the phone without bothering to look at the number. “Don’t you people ever think about time zones?” she asked. Then sat up straighter.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What?” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You’re not serious,” she said.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And cursed again, not bothering to whisper this time.")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("A week later found her over the Atlantic, encased within a sleek, gleaming cylinder, its occupants as well-upholstered as the seats, not a Kalashnikov in sight. She’d spent so much time among the casually over-armed that the sudden absence of weaponry unnerved her. Below, the rumpled grey sheet of ocean billowed and flattened. Lola shifted, trying to get comfortable, and apologized for elbowing the person next to her. She wondered when her newspaper had stopped paying for business class on overseas flights. She was too tall for coach. Still, she took a moment to savor the fact that the people around her seemed to take things like flight attendants and readily available alcohol for granted. She calculated drink against dosage, broke a sleeping pill in half, and signaled for a glass of wine. She’d already prowled the cabin’s aisles twice, staring hard-eyed at her fellow passengers. But she’d been gone too long. They all looked alike. She’d lost the ability to read her own kind. The pill lay halved and crumbly-edged on her tray table. She couldn’t remember the last time she’d tried to sleep on a plane. She’d spent too many years trying to get to the sorts of places that sane people sought to leave, traveling there on rusting prop planes of questionable pedigree flown by pilots of dodgy background under conditions that made her wonder why she’d ever fretted over an assignment of window versus aisle, each new trip a gut-liquefying opportunity to wonder when luck would turn on her, demanding payment for past excesses of hubris. She didn’t sleep on planes but she would damn well sleep on this one, grab a few hours of obliviousness to stave off the reality of that phone call. She scooped up both halves of the sleeping pill and swallowed them dry. She hit the call button again. The attendant was at the front of the plane, the first-class curtain pulled aside, speaking to someone there. She glanced back and kept talking. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola balled her napkin within her fist. She leaned into the aisle. Such a short, straight shot, almost too easy, even given the improbable physics of wadded paper and pressurized cabin air. She cocked her arm, then whipped it forward. The napkin streaked the length of the aisle and hit the attendant between the shoulder blades, bouncing into someone’s drink with a soggy splash. Lola pressed the call button again. The flight attendant turned, her face an unmistakable emergency warning. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola lifted her plastic up. “Another, please.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-flush-left",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("In Baltimore, an editor, one of the new ones, tilted back in his chair and avoided her eyes. “It’s not personal,” he said. “We’re shuttering all the foreign bureaus. We’ll find you something here. Maybe in one of the suburban offices. The layoffs left us pretty thin out there. At least you’ll still have a job. Consider yourself lucky.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola examined a paperweight of milky swirled glass that sat between a file and a newspaper on his desk. It looked heavy. She picked it up. It was. “The suburbs. Lucky me.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Floor-to-ceiling windows formed one wall of the office, the legacy of a newsroom renovation dating to the days when profits sloshed through the paper, spilling over into heralded new foreign bureaus, yearlong prize-savvy investigative projects, and wink-and-nod expense accounts. That tide had swept out a long time ago, leaving behind pay cuts and layoffs and unpaid furloughs. Packing boxes sat atop several desks in the newsroom. Others looked as though they’d been bare for months. Stubborn cracks left unrepaired veined the tall windows. Grit dulled their surface. The popcorn burst of automatic weapons fire sounded faintly through them, and Lola counted silently, reckoning the distance, before she saw the man hunched at the curb, a jackhammer anchoring his bobbling torso.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I’d be reporting on school boards,” Lola said. “Zoning hearings. Neighbors pointing lawyers at each other over a foot of property line.” She tossed the paperweight high. It dropped into her palm with a satisfying sting. ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“There’ll be some of that. It’s what people care about.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Interns cover that shit.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“We don’t have interns anymore. Haven’t for three or four years now. You’ve been overseas a long time. You don’t even have a smartphone, do you? We’ve got plenty of younger reporters in the suburbs who can get you up to speed on the technology. Look, would you mind putting that down? It’s expensive.” His cheeks were pink and smooth, his shirt starched and palely gleaming against the fine dark weave of his blazer. Lola tried to remember a life that allowed for easy cleanliness. She straightened her legs, taking up too much room in the too-small office, the scuffed toes of her cleated hiking boots nearly touching his pretty polished loafers. Standing, she had six inches on him.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“You can’t pull me out now,” she said. “The warlords are re-arming. Somewhere, somehow, someone’s getting money to them—a lot of money. Not to put too fine a point on it, but what’s going on there is going to determine the course of history for the next decade at the very least. You know that. And yet you put today’s story from Afghanistan on … “ She exchanged the paperweight for the newspaper. She turned the pages, counting aloud. “Page One—no. Two—no, not there either. Three, four—Here’s something about everyone Twittering a crotch shot of an actress with no undies. That one’s right above a story about a massacre in Congo. Glad to see you’ve got your priorities in order.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Tweeting.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Never mind. The wire services can cover Afghanistan.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Damn it!” She rolled up the paper and slapped it against his desk. The paperweight shuddered. “The wires services aren’t getting the job done. They’ve had layoffs, too, in case you haven’t noticed. The only guy the AP’s got left in Kabul is too scared to leave the city. He does most of his work by phone. But I’m out there where it’s all happening. "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Was")]), _vm._v(" there. Until you called.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He reached across the desk and took the newspaper from her. “Our readers care more about how a property tax increase is going to affect them right now than they do about how things in Afghanistan are going to shake out in ten years.” He opened the file and slid some forms from it. “You’ve got some—a lot—of time off coming. You haven’t taken a vacation in years. It’s really played hell with our accounting. You have to take it. Go get some R and R.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola hefted the paperweight again and looked at the ceiling. “I’ll take it back in Kabul. Softball amounts to R and R. I play a lot of softball. I’m the pitcher on the Kabul Kabooms. We’re on track to take the championship away from the Talibanieri.” Her hand flashed. The paperweight shot up and rocketed back down. She snatched it from the air above his head. “Do you really want the Italians to beat us at our own game?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Jesus Christ.” He righted himself in his chair. “All of you correspondents are a pain in the ass when you come back. It’s June. The way I count up all this time, we’ve got to give you something like ten weeks off with pay. That’ll take you until nearly September. You should be housebroken again by then. Take that vacation. Given that we budgeted for flights home that you never took, we’ll pay plane fare—within reason. Don’t go to Tahiti. And don’t run up a big hotel bill. Go someplace where you can sponge off friends. "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Put that damn thing down")]), _vm._v(".”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t know anybody here anymore. You laid them all off. Except for one who beat you to the punch.” She realized, too late, that she’d given him an opening.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Who’s that?” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Mary Alice Carr,” she said slowly, wishing she’d thought to offer up another name. “She left a few years ago, back when this place was still giving buyouts. Before your time, I think.” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("But he nodded. “I remember her. She left right after I got here. Went to some crazy place. Idaho, Wyoming, something like that. She called us a couple of weeks ago.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Montana. What did she want?”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“She was all excited about something happening out there, trying to sell us the story. Some delusional person sent her my way.” He grimaced. “She didn’t know we’d gone all local-local in our news coverage. No reason to buy a national story, and no freelance budget for one, anyway, even if we had been interested. Which we weren’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lola stood. “I’ve really got the whole summer off?” ")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Legally, we’ve got to give you the time. Something I’m short on.” He looked pointedly at the message light blinking on his phone. “Go to Montana, then. Fly-fish, ride horses, whatever it is they do out there. We still have a travel agent. I’ll have her make the arrangements before they cancel that contract, too.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I don’t fish,” Lola said. “And I don’t like horses. I don’t see why it’s a problem for me to just go back to Kabul and finish up what I was working on. I’ll see you in September.” Like hell she would. But first she had to get back. She could figure out how to stay later.")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He pushed his chair back. “I don’t think you understand,” he said. “You "), _c('span', {
    staticClass: "Italic-Style",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("are")]), _vm._v(" finished over there. You can drop off your laptop and satellite phone with the clerk. You won’t need them anymore. As of the minute you walked through this door, we no longer have any more foreign bureaus.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“I left the sat phone in Kabul, along with my body armor and all the rest of my stuff. I should go back and get it.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("“Nice try,” he said. “Just have those French freaks you live with—the ones who think it’s so funny to answer your phone and hang up on me when I try to call—ship your stuff. You’re not going back. We’ve already canceled your company credit card and the travel account.”")]), _vm._v(" "), _c('p', {
    staticClass: "text-indented-space-after",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("He kept talking but Lola’s focus shifted to a panel truck, the perfect size to hold a dozen oil drums packed with a sludgy mix of fertilizer and racing fuel, moving slowly past the building. Lola stared hard at the driver, watching for the quick yank at the wheel that would send the truck into the lobby, the thumb to the detonator that would follow. The concussive force would bend the newsroom windows outward, the panes bubbling like a soapy mass across along the face of the building, then suck them back in with such speed and intensity that the glass would burst, shards rocketing across the office, razoring through furniture, paper, flesh. Lola blew out a breath, slammed the door behind her and strode the length of the underpopulated newsroom, the stupid expensive paperweight in her pocket banging against her thigh with each step.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-292d5c70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781504084789-1.vue
// module id = 75
// module chunks = 0